<template>
  <div class="footer">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 form-container">
          <p class="header text-center">Get in touch</p>
          <div v-if="sent || loading" class="d-flex centered">
            <div v-if="loading" class="d-flex centered">
              <div class="spinner-border text-success" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <div v-else>
              <div class="d-flex centered">
                <font-awesome-icon
                  :icon="['fas', 'thumbs-up']"
                  size="2xl"
                  class="text--green" />
              </div>
              <p class="text--green text-center mt-3">
                Thank You!
                <br />
                Your message has been sent successfully
                <br />I will get back to you as soon as possible
              </p>
            </div>
          </div>
          <form
            v-else
            class="needs-validation"
            :class="{'was-validated': invalid}"
            novalidate
            @submit.prevent="submit">
            <div class="d-flex">
              <div class="col-6 subject-spacing">
                <input
                  type="text"
                  placeholder="Subject"
                  class="form-control"
                  id="FormControlSubject"
                  required
                  v-model="formData.subject"
                  @input="sent = false" />
              </div>
              <div class="col-6 email-spacing">
                <input
                  type="email"
                  placeholder="Email"
                  class="form-control"
                  id="FormControlEmail"
                  required
                  v-model="formData.email"
                  @input="sent = false" />
                <div class="invalid-feedback">
                  Please enter a valid email address
                </div>
              </div>
            </div>
            <div>
              <textarea
                id="FormControlMessage"
                class="form-control mt-3"
                placeholder="Message"
                aria-label="With textarea"
                rows="5"
                required
                v-model="formData.message">
              </textarea>
            </div>
            <div class="d-flex send-button mt-3">
              <button class="btn button col-12" type="submit">SEND</button>
            </div>
          </form>
        </div>
        <div class="col-lg-4 row">
          <div class="col-6 link-wrapper">
            <div>
              <p class="header text-align-start">Important Links</p>
              <div>
                <navbar-link
                  class="link"
                  name="About Me"
                  to=""
                  @click="scrollToTop" />
                <navbar-link
                  class="link"
                  name="Projects"
                  @click="scrollToTop" />
                <navbar-link class="link" name="Contact" @click="scrollToTop" />
                <!-- <navbar-link class="link" name="Resume" @click="scrollToTop" /> -->
              </div>
            </div>
          </div>

          <div class="col-6 link-wrapper">
            <div>
              <!-- <p class="header">Lets talk</p>
              <p>
                <a href="tel:0415314433" class="white text-decoration-none link"
                  >0415 314 433</a
                >
              </p> -->
              <p>Feel free to reach out! I'm open to new connections.</p>
              <div class="d-flex">
                <a href="mailto:mohammadrk804@gmail.com">
                  <font-awesome-icon
                    :icon="['fas', 'envelope']"
                    size="2xl"
                    class="text--green" />
                </a>
                <a
                  href="https://www.linkedin.com/in/mohammad-karim-331559164"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="icon--spacing">
                  <font-awesome-icon
                    :icon="['fab', 'linkedin']"
                    size="2xl"
                    class="text--green" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-5" />
      <p class="text-center">
        &copy; {{ new Date().getFullYear() }} Mohammad Karim. All rights
        reserved.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import {ref, watch} from 'vue';
import store from '@/store';

import NavbarLink from './NavbarLink.vue';
import {contact} from '../service/contactService';
import {isValidEmail} from '../util/generalUtil';

const sent = ref(false);
const loading = ref(false);
const invalid = ref(false);

watch(
  () => store.state.emailSent,
  value => {
    if (value) {
      sent.value = store.state.emailSent;
    }
  },
);

const scrollToTop = () => {
  window.scrollTo(0, 0);
};

const formData = {
  subject: '',
  email: '',
  message: '',
};

const submit = async () => {
  try {
    if (
      !isValidEmail(formData.email) ||
      formData.subject.trim() === '' ||
      formData.message.trim() === ''
    ) {
      invalid.value = true;
      return;
    }
    loading.value = true;
    setTimeout(() => {
      loading.value = false;
      sent.value = true;
      store.dispatch('setEmailSent', true);
    }, 2000);
    await contact({
      subject: formData.subject,
      email: formData.email,
      message: formData.message,
    });
  } catch (error) {
    loading.value = false;
    sent.value = true;
  }
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: var(--dark-mode-secondary-bg);
  color: white;
  padding: 10px;
  padding-top: 20px;
}

@media screen and (min-width: 768px) {
  .form-container {
    padding: 0 100px;
  }
}
@media screen and (max-width: 992px) {
  .link-wrapper {
    margin-top: 20px;
  }
}

.header {
  font-size: 20px;
  font-weight: 700;
}

.subject-spacing {
  padding-right: 5px;
}
.email-spacing {
  padding-left: 5px;
}

.link-wrapper {
  display: flex;
  justify-content: center;
}

.link {
  font-size: large;
  margin-top: 5px;
}

.icon--spacing {
  margin-left: 20px;
}
</style>
